import { mapDepartmentDetailsToRequest, mapSearchDetailsToRequest } from '../dataHandling';
import mapProductArticleDetailsToRequest from '../mapProductArticleDetailsToRequest';
import mapProductArticleDetailsToRequestForBrands from '../mapProductArticleDetailsToRequestForBrands';
const getSettingsForEsalesQuery = ({ praConfiguration, articledata, articleId, pralocale, baseProductCode, stylewitharticles, categoryparentkey, queryPayload, }) => {
    const { ID, API, BRAND } = praConfiguration;
    let payload = null;
    if (ID === 'SWG') {
        if ((BRAND === 'hm' || BRAND === 'northstar') && articledata) {
            payload = mapProductArticleDetailsToRequest(articledata, articleId);
        }
    }
    else if (ID === 'PRA1') {
        if ((BRAND === 'hm' || BRAND === 'northstar') && articledata) {
            payload = mapProductArticleDetailsToRequest(articledata, articleId);
        }
        else if (BRAND !== 'hm' && BRAND !== 'northstar') {
            payload = mapProductArticleDetailsToRequestForBrands(baseProductCode, pralocale, categoryparentkey, stylewitharticles);
        }
    }
    else if (ID === 'PRA6' || ID === 'PRA11') {
        payload = mapDepartmentDetailsToRequest(queryPayload);
    }
    else if (ID === 'PRA10') {
        payload = mapSearchDetailsToRequest();
    }
    else if (ID === 'PRA15' || ID === 'PRA3' || ID === 'PRA4') {
        // no specific payload for PRA15, PRA3, PRA4
        payload = {};
    }
    // to get brand specific data mock
    if (payload && process.env.NODE_ENV === 'development') {
        payload.brand = BRAND;
    }
    return (payload && {
        payload,
        path: API.PATH,
    });
};
export default getSettingsForEsalesQuery;
//# sourceMappingURL=getSettingsForEsalesQuery.js.map